<template>
  <div class="container">
    <header class="jumbotron">
      <!-- <h3>{{ content }}</h3> -->
      <h5>{{ message }}</h5>
      <div v-if="roles.length > 0">
        <h2>Stevne administratorer  ({{ this.$route.params.competition_id }})</h2>
        <table class="table">
          <thead>
            <tr>
              <th>Nummer</th>
              <th>Navn</th>
              <!-- <th>Rolle</th>
              <th>Detaljer 1</th>
              <th>Detaljer 2</th> -->
              <th>Beskrivelse</th>
              <!-- <th>Arrangør</th>
              <th>Stevne ID</th> -->
            </tr>
          </thead>
          <tbody>
            <tr v-for="(role, index) in roles" :key="index">
              <td>{{ role.username }}</td>
              <td>{{ role.vippsuser ? role.vippsuser.name : '' }}</td>
              <!-- <td>{{ role.name }}</td>
              <td>{{ role.details1 }}</td>
              <td>{{ role.details2 }}</td> -->
              <td>{{ role.description }}</td>
              <!-- <td>{{ role.organizer }}</td>
              <td>{{ role.competition_id }}</td> -->
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else>
        <p>Ingen competition_admin?</p>
      </div>
      <router-link :to="'/competition/'+currentCompetition_computed+'/admin/add'" class="nav-link">
        <font-awesome-icon icon="user-plus" /> Legg til stevne administrator
      </router-link>
    </header>
  </div>
</template>

<script>
import UserService from '../services/user.service';

export default {
  name: 'User',
  data() {
    return {
      content: '',
      message: '',
      roles: []
    };
  },
  mounted() {
    UserService.getModeratorBoard(this.$route.params.competition_id).then(
      response => {
        console.log("getModeratorBoard - success")
        this.content = response.data;
        this.roles = response.data;
      },
      error => {
        if (error.response.status == 440) {
          if (error.response && error.response.data.message) {
            this.content = error.response.data.message;
            this.message = "(" + error.response.data.timedouttime + ")";
          } else {
            this.content =
              (error.response && error.response.data) ||
              error.message ||
              error.toString();
          }
          setTimeout(() => {
            this.logOut();
          }, 3000);
        } else {
          this.content =
            (error.response && error.response.data) ||
            error.message ||
            error.toString();
        }
      }
    );
  },
  methods: {
    logOut() {
      this.$store.dispatch('auth/logout');
      this.$router.push('/');
    }
  }
};
</script>
